// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5513":"4e6e7ae1","9764":"46849aca"}[chunkId] + ".chunk.css";
};